import Layout from '@/layout';
import { getDeviceTrackReplayPath, trackReplayRouteList } from '../utils/deviceTrack';
import { isEmpty } from '@/utils/is';

export default {
  path: '/query',
  component: Layout,
  meta: {
    title: '综合查询',
    code: '010203',
    icon: 'el-icon-search'
  },
  children: [
    {
      path: '',
      component: () => import('@/views/query/monirecord'),
      meta: {
        title: '监测记录',
        icon: 'iconfont icon-jiancejiluchaxun',
        code: '01020304'
      }
    },
    {
      path: 'hisWarn/:sn?/:deviceType?',
      name: 'hisWarn',
      component: () => import('@/views/query/history'),
      props: true,
      meta: {
        title: '历史报警',
        icon: 'iconfont icon-jiankong-baojinglishi',
        code: '01020301'
      }
    },
    {
      path: 'efm100CheckList/:sn?',
      name: 'efm100CheckList',
      component: () => import('@/views/query/check/emf100-checkList'),
      props: true,
      meta: {
        title: '检测记录',
        icon: 'el-icon-notebook-2',
        code: '01020315'
      }
    },
    {
      path: 'efm100-checkdetail/:testId/:deviceType',
      name: 'efm100-checkDetail',
      props: true,
      component: () => import('@/views/query/check/emf100-checkList/check-detail'),
      meta: {
        activeMenu: '/query/checkList'
      }
    },
    {
      path: 'checkList/:sn?',
      name: 'CheckList',
      component: () => import('@/views/query/check/checkList'),
      props: true,
      meta: {
        title: '检测记录',
        icon: 'el-icon-notebook-2',
        code: '01020302'
      }
    },
    {
      path: 'checkdetail/:testId/:deviceType',
      name: 'CheckDetail',
      props: true,
      component: () => import('@/views/query/check/checkDetail'),
      meta: {
        activeMenu: '/query/checkList'
      }
    },
    {
      path: 'state/:sn?',
      name: 'StateList',
      component: () => import('@/views/query/state'),
      props: true,
      meta: {
        title: '设备状态',
        icon: 'iconfont icon-shebeizhuangtai',
        code: '01020303'
      }
    },
    {
      path: 'track/list',
      name: 'DeviceTrackReplayList',
      component: () => import('@/views/query/deviceTrackReplay'),
      props: true,
      meta: {
        title: '设备轨迹',
        icon: 'iconfont icon-nav',
        code: '01020311'
      }
    },
    {
      path: 'track/replay',
      name: 'DeviceTrackReplayDetails',
      component: () => import('@/views/deviceTrack/index.vue'),
      redirect: to => {
        const { query } = to;
        const name = getDeviceTrackReplayPath(query);

        if (isEmpty(name)) {
          return '404';
        }

        return { name, query };
      },
      children: trackReplayRouteList,
      meta: {
        hidden: true
      }
    },
    {
      path: 'gd606/record',
      name: 'GD606Record',
      component: () => import('@/views/query/GD606Record'),
      props: true,
      meta: {
        title: '复合检测记录',
        icon: 'el-icon-notebook-2',
        code: '01020305'
      }
    },
    {
      path: 'fault/:sn?',
      name: 'faultRecord',
      component: () => import('@/views/query/fault'),
      props: true,
      meta: {
        title: '故障记录',
        icon: 'iconfont icon-fault',
        code: '01020306'
      }
    },
    {
      path: 'sample/:sn?',
      name: 'sampleRecord',
      component: () => import('@/views/query/sample'),
      props: true,
      meta: {
        title: '采样记录',
        icon: 'el-icon-notebook-1',
        code: '01020307'
      }
    },
    {
      path: 'replay/:sn?',
      name: 'taskReplay',
      component: () => import('@/views/query/taskReplay'),
      props: true,
      meta: {
        title: '任务回放',
        icon: 'iconfont icon-job',
        code: '01020308'
      }
    },
    {
      path: 'trackReplay',
      name: 'trackReplay',
      component: () => import('@/views/query/trackReplay/index'),
      redirect: 'trackreplay/list',
      meta: {
        title: '走航回放',
        icon: 'iconfont icon-nav',
        code: '01020309'
      },
      children: [
        {
          path: 'list',
          name: 'trackReplayList',
          component: () => import('@/views/query/trackReplay/list'),
          props: true,
          meta: {
            hidden: true,
            activeMenu: '/query/trackReplay'
          }
        },
        {
          path: 'details/:id?',
          name: 'trackReplayDetails',
          component: () => import('@/views/query/trackReplay/details'),
          props: true,
          meta: {
            hidden: true,
            activeMenu: '/query/trackReplay'
          }
        }
      ]
    },
    {
      path: 'material',
      name: 'Material',
      redirect: 'material/list',
      component: () => import('@/views/query/material/index.vue'),
      meta: {
        title: '物质查询',
        icon: 'iconfont icon-material',
        code: '01020310'
      },
      children: [
        {
          path: 'list',
          name: 'MaterialList',
          component: () => import('@/views/query/material/list.vue'),
          props: true,
          meta: {
            activeMenu: '/query/material',
            hidden: true
          }
        },
        {
          path: 'details/:materialId?',
          name: 'MaterialDetails',
          component: () => import('@/views/query/material/details.vue'),
          props: true,
          meta: {
            activeMenu: '/query/material',
            hidden: true
          }
        }
      ]
    },
    {
      path: 'nuclide',
      name: 'Nuclide',
      component: () => import('@/views/query/nuclide/index.vue'),
      meta: {
        title: '核素查询',
        icon: 'iconfont icon-menu-weixianpinmatou',
        code: '010724'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
